import {
  WSButton,
  WSCheckboxToggle,
  WSText
} from "@wingspanhq/fe-component-library";
import { PaymentRequirementStrategy } from "@wingspanhq/payments/dist/interfaces";
import { useWSMutation } from "@ws-react-query";
import React, { useState } from "react";
import { AutopaySetupParams } from ".";
import { QUERY_PAYEE } from "../../../../query/payee/keys";
import { updatePayee } from "../../../../services/payees";
import { SetupRouteComponentProps } from "../../../../shared/components/FlowSetup";
import { useSetWSStore } from "../../../../store";
import { SetupAutopayLayout } from "./SetupAutopayLayout";

export const SetupConsent: React.FC<
  SetupRouteComponentProps<AutopaySetupParams>
> = ({ onBack, onNext, params }) => {
  const [agreement, setAgreement] = useState(false);
  const setStore = useSetWSStore();

  const [submit, submitMeta] = useWSMutation(
    async () => {
      if (!params?.payeeId) return;

      await updatePayee(params.payeeId, {
        payerOwnedData: {
          autoPayStrategy: PaymentRequirementStrategy.All
        }
      });

      // clear setup autopay data;
      window.sessionStorage.removeItem("signUpAutopayDetails");
      setStore({ signUpAutopayDetails: undefined });
    },
    {
      onSuccess: onNext,
      dependencies: [[QUERY_PAYEE, params?.payeeId]]
    }
  );

  if (!params?.payeeId) {
    return null;
  }

  return (
    <SetupAutopayLayout
      payeeId={params.payeeId}
      onBack={onBack}
      title={payeeName => `Consent to paying ${payeeName} automatically?`}
    >
      {({ payeeName }) => (
        <>
          <WSText mb="XL">
            {`Easily automate your ${payeeName} invoice payments with our Autopay feature.`}
          </WSText>
          <WSText>
            By enrolling, you authorize us to securely charge your payment
            method for each invoice, ensuring timely and hassle-free
            transactions. Review the terms, provide your consent, and let
            Autopay manage the rest.
          </WSText>

          <WSCheckboxToggle
            my="XL"
            name="agreenment"
            label={`I agree to enroll in Autopay for ${payeeName}`}
            value={agreement}
            onChange={value => {
              setAgreement(value);
            }}
          />

          <WSButton
            disabled={!agreement}
            fullWidth
            onClick={submit}
            loading={submitMeta.isLoading}
          >
            Continue
          </WSButton>
        </>
      )}
    </SetupAutopayLayout>
  );
};
